module.exports = __webpack_public_path__ + "static/media/quickbook.c129c757.svg";